import { initializeApp } from 'firebase/app';
import { connectAuthEmulator, getAuth, GoogleAuthProvider } from 'firebase/auth';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';
import { getRemoteConfig, fetchAndActivate } from 'firebase/remote-config';

// Use environment variables for Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();

// Initialize Remote Config
export const remoteConfig = getRemoteConfig(app);
remoteConfig.settings.minimumFetchIntervalMillis = 3600000; // 1 hour in development

// Analytics is only available in the browser
let analytics = null;

// Initialize analytics if in browser
if (typeof window !== 'undefined') {
  try {
    const analyticsInstance = getAnalytics(app);
    analytics = analyticsInstance;
  } catch (error) {
    console.error('Failed to initialize analytics:', error);
  }
  
  // Connect to emulators in development
  if (process.env.NODE_ENV === 'development' && window.location.hostname === 'localhost') {
    try {
      connectFirestoreEmulator(db, 'localhost', 8081);
      connectAuthEmulator(auth, 'http://localhost:9098', { disableWarnings: true });
      console.log('Using Firebase emulators');
    } catch (error) {
      console.error('Failed to connect to Firebase emulators:', error);
    }
  }
}

export { analytics, fetchAndActivate }; 